import { render } from "./templateVariable.vue?vue&type=template&id=1c988b80"
import script from "./templateVariable.vue?vue&type=script&lang=js"
export * from "./templateVariable.vue?vue&type=script&lang=js"

import "./templateVariable.vue?vue&type=style&index=0&id=1c988b80&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__